<template>
  <div>
    <div>
      <div class="text-h6 title-box"> 
        <v-btn
          color="primary"
          class="circle-btn"
          rounded
          small
          outlined
        >
          {{ localJourneyStep.order }}
        </v-btn>
        {{ localJourneyStep.title }}</div>
      <div class="text-body-1 subtitle-box">path: {{ localJourneyStep.key }}</div>
      <div class="text-body-1 box">{{ localJourneyStep.description }}</div>
      <div class="actions">
        <v-btn class="primary-btn" @click="editNode">Edit</v-btn>
        <v-btn class="danger-btn" @click="deleteNode">Delete</v-btn>
      </div>
      <div ref="editableDiv" contenteditable="true" hidden df-nodedata></div>
    </div>

    <node-editor v-if="journeyStep" v-model="localJourneyStep" :show.sync="showNodeEditor" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex"
import NodeEditor from "./NodeEditor";
import WaitingDialog from '../Dialogs/WaitingDialog.vue';
import ConfirmDialog from '../Dialogs/ConfirmDialog.vue';

export default {
  components: {
    NodeEditor,
  },
  data() {
    return {
      showNodeEditor: false,
      observer: null,
      nodedata: {
        title: null,
        key: null,
        description: null,
      },
      localJourneyStep: {
        title: null,
        key: null,
        description: null,
      },
    };
  },
  watch: {
    value(newValue) {
      if (this.$refs.editableDiv.innerText !== newValue) {
        this.$refs.editableDiv.innerText = newValue
      }
    },
    journeyStep(newJourneyStep) {
      if (newJourneyStep) {
        this.localJourneyStep = newJourneyStep;
      }
    },
  },
  computed: {
    ...mapGetters('journey', ['currentJourneyStep', 'currentJourneySteps']),
    journeyStep() {
      return this.nodedata.key ? this.currentJourneyStep(this.nodedata.key) : this.nodedata;
    }
  },
  methods: {
    ...mapActions('journey', ['saveJourneySteps', 'deleteJourneyStep']),
    ...mapMutations('journey', ['updateCurrentJourneyStep', 'setNeedToRefreshCanvas']),
    setupMutationObserver() {
      const config = { characterData: true, childList: true, subtree: true }
      this.observer = new MutationObserver(this.handleMutation)
      this.observer.observe(this.$refs.editableDiv, config)
    },
    handleMutation(mutations) {
      for (let mutation of mutations) {
        if (mutation.type === 'characterData' || mutation.type === 'childList') {
          try {
            let obj = JSON.parse(this.$refs.editableDiv.innerText)
            this.nodedata.title = obj.title
            this.nodedata.description = obj.description
            this.nodedata.key = obj.key
          } catch (error) {
            console.error('Failed to parse JSON from editableDiv:', error)
          }
          break
        }
      }
    },
    destroyMutationObserver() {
      if (this.observer) {
        this.observer.disconnect()
        this.observer = null
      }
    },
    async deleteNode() {
      if (!(await this.isRemoveNode())) {
        return;
      }
      this.$modal.show(WaitingDialog, {
        title: 'Removing step from journey...',
        message: 'Please wait whilst the step is being removing',
      })
      // delete journey step from store and refresh the canvas
      try {
        const journeyStep = this.currentJourneyStep(this.nodedata.key);
        await this.deleteJourneyStep(journeyStep);
        // get all journey steps and update it
        const removedKey = this.nodedata.key;
        const journeySteps = this.currentJourneySteps.filter(journeyStep => {
          return journeyStep.conditions.some(condition => condition.step === removedKey);
        });
        journeySteps.forEach(journeyStep => {
          journeyStep.conditions = journeyStep.conditions.filter(condition => condition.step !== removedKey);
          this.updateCurrentJourneyStep(journeyStep);
        });
        await this.saveJourneySteps();
        this.setNeedToRefreshCanvas(true);
        this.$modal.submit();
        this.$modal.show(ConfirmDialog, {
          title: "Journey Step Deletion Successful",
          message: "The journey step was deleted successfully.",
          confirmText: "Confirm",
        })
      } catch (error) {
        this.$modal.submit();
        this.$modal.show(ConfirmDialog, {
          title: "Failed to delete the journey step",
          message: error,
          confirmText: "Confirm",
        })
      }
    },
    async isRemoveNode () {
      return this.$modal.show(ConfirmDialog, {
        title: "Delete Journey Step",
        message: `Journey Step ${this.nodedata.key} will be deleted from Journey.`,
        confirmText: "Delete",
        cancelText: "Cancel",
        confirmButtonColor: 'md-danger'
      });
    },
    editNode() {
      this.showNodeEditor = true;
    },
  },
  mounted() {
    this.setupMutationObserver()
  },
  beforeDestroy() {
    this.destroyMutationObserver()
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/theme.scss";
.primary-btn {
  color: white;
  background-color: $ausloans-blue !important;
}

.danger-btn {
  color: white;
  background-color: $ausloans-red !important;
}

.circle-btn {
  width: 30px !important;
    height: 30px !important;
    padding: 0 !important;
    font-size: 16px;
    text-align: center;
    min-width: 30px !important;
}
</style>